import Store from '@/store/index'
import Presets from '@/utils/presets/index'
import {
  localStorageConfigsName
} from '@/utils/types'
import { CheckForSavedConfigsCtx } from '@/utils/interfaces'
const { YellowTheme, PIQGreenTheme } = Presets

let globalCssVars: any = {}

export const setCssThemeVars = (color: string = 'yellow'): void => {
  // Available options: see themeOptions array in gamblingContext.ts
  const themeObjects: object | any = {'--background-color': ''}
  if (color === 'yellow') {
    themeObjects['--background-color'] = '#ffeb3b;'
    themeObjects['--button-color'] = '#333333;'
    themeObjects['--toolbar-background'] = 'linear-gradient(45deg, #847c34, #312f21);'
    themeObjects['--background-linear'] = 'linear-gradient(45deg, #ffeb3b, #312f21);'
    themeObjects['--color'] = 'yellow;'
    themeObjects['--border-color'] = 'yellow;'
    themeObjects['--active-color'] = 'yellow;'
    themeObjects['--casino-bg'] = '#ff5252;'
    themeObjects['--text-on-bg'] = '#333333;'
    themeObjects['--main-color'] = '#e8d631;'
    themeObjects['--secondary-bg'] = '#23231d;'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #ffeb3b 400px, #000000ad 800px);'
    themeObjects['--layout-two-main-bg'] = '#afa12f;'
    themeObjects['--text-on-layout-two-bg'] = '#ffffff;'
  } else if (color === 'PIQGreen') {
    themeObjects['--background-color'] = '#27B005;'
    themeObjects['--button-color'] = '#ffffff;'
    themeObjects['--toolbar-background'] = 'linear-gradient(315deg,#1a7503 10%,#27B005,#0d3b06,#34d406);'
    themeObjects['--background-linear'] = '#ffffff'
    themeObjects['--color'] = '#ffffff;'
    themeObjects['--border-color'] = '#27B005;'
    themeObjects['--active-color'] = '#ffffff;'
    themeObjects['--casino-bg'] = '#3a7a2a;'
    themeObjects['--text-on-bg'] = '#ffffff;'
    themeObjects['--main-color'] = '#27B005;'
    themeObjects['--secondary-bg'] = '#0d3b06;'
    themeObjects['--icon-bg'] = '#d4f5c8;'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #27B005 400px, #000000ad 800px);'
    themeObjects['--layout-two-main-bg'] = '#1e8c04;'
    themeObjects['--text-on-layout-two-bg'] = '#ffffff;'
  } else if (color === 'blue') {
    themeObjects['--background-color'] = '#8bc2ee;'
    themeObjects['--button-color'] = '#ffffff;'
    themeObjects['--toolbar-background'] = 'linear-gradient(45deg, #8bc2ee, #88bfe947);'
    themeObjects['--background-linear'] = 'linear-gradient(45deg, #8bc2ee, #88bfe947);'
    themeObjects['--color'] = '#ffffff;'
    themeObjects['--border-color'] = '#8bc2ee;'
    themeObjects['--active-color'] = '#ffffff;'
    themeObjects['--casino-bg'] = '#8bc2ee;'
    themeObjects['--text-on-bg'] = '#ffffff;'
    themeObjects['--main-color'] = '#8bc2ee;'
    themeObjects['--secondary-bg'] = '#f1f1f1;'
    themeObjects['--icon-bg'] = '#8bc2ee;'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #8bc2ee 400px, #000000ad 800px);'
  } else if (color === 'red') {
    themeObjects['--background-color'] = '#ff525e;'
    themeObjects['--button-color'] = '#ffffff;'
    themeObjects['--toolbar-background'] = 'linear-gradient(45deg, #f28c93, #4a2c2e);'
    themeObjects['--background-linear'] = 'linear-gradient(45deg, #ff525e, #4a2c2e);'
    themeObjects['--color'] = '#ff656f;'
    themeObjects['--border-color'] = '#ff525e;'
    themeObjects['--active-color'] = '#ffffff;'
    themeObjects['--casino-bg'] = '#ff5252;'
    themeObjects['--text-on-bg'] = '#ffffff;'
    themeObjects['--main-color'] = '#ff525e;'
    themeObjects['--secondary-bg'] = '#ffffff00;'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #ff525e 400px, #000000ad 800px);'
    themeObjects['--layout-two-main-bg'] = '#fe525e;'
    themeObjects['--text-on-layout-two-bg'] = '#ffffff;'
  } else if (color === 'green') {
    themeObjects['--background-color'] = '#00ff4d;'
    themeObjects['--button-color'] = '#333333;'
    themeObjects['--toolbar-background'] = 'linear-gradient(45deg, #036922, transparent);'
    themeObjects['--background-linear'] = 'linear-gradient(45deg, #00ff4d, transparent);'
    themeObjects['--color'] = '#00ff4d;'
    themeObjects['--border-color'] = '#00ff4d;'
    themeObjects['--active-color'] = '#00ff4d;'
    themeObjects['--casino-bg'] = '#009e30;'
    themeObjects['--text-on-bg'] = '#333333;'
    themeObjects['--main-color'] = '#00ff4d;'
    themeObjects['--secondary-bg'] = '#f1f1f1;'
    themeObjects['--icon-bg'] = '#009e30;'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #00ff4d 400px, #000000ad 800px);'
  } else if (color === 'darkgrey') {
    themeObjects['--background-color'] = '#2f4f4f;'
    themeObjects['--button-color'] = '#ffffff;'
    themeObjects['--toolbar-background'] = 'linear-gradient(45deg, #205454, #133333);'
    themeObjects['--background-linear'] = 'linear-gradient(45deg, #2f4f4f, #133333);'
    themeObjects['--color'] = '#ffffff;'
    themeObjects['--border-color'] = '#ffffff;'
    themeObjects['--active-color'] = '#ffffff;'
    themeObjects['--casino-bg'] = '#2f4f4f;'
    themeObjects['--text-on-bg'] = '#ffffff;'
    themeObjects['--main-color'] = '#458888;'
    themeObjects['--secondary-bg'] = '#1a4243;'
    themeObjects['--icon-bg'] = '#99cfd2;'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #2f4f4f 400px, #000000ad 800px);'
    themeObjects['--layout-two-main-bg'] = '#205252;'
    themeObjects['--text-on-layout-two-bg'] = '#ffffff;'
  } else if (color === 'royalGreen') {
    themeObjects['--background-color'] = 'linear-gradient(to right, #34e89e, #0f3443);'
    themeObjects['--button-color'] = '#ffffff;'
    themeObjects['--toolbar-background'] = 'linear-gradient(to right, #4de0a4, #0f3443);'
    themeObjects['--background-linear'] = 'linear-gradient(to right, #34e89e, #0f3443);'
    themeObjects['--color'] = '#34e89e;'
    themeObjects['--border-color'] = 'linear-gradient(to right, #34e89e, #0f3443);'
    themeObjects['--active-color'] = '#ffffff;'
    themeObjects['--casino-bg'] = 'linear-gradient(to right, #34e89e, #0f3443);'
    themeObjects['--text-on-bg'] = '#ffffff;'
    themeObjects['--main-color'] = '#319478;'
    themeObjects['--secondary-bg'] = 'linear-gradient(to right, #236c63, #0f3543);'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #34e89e 400px, #000000ad 800px);'
    themeObjects['--layout-two-main-bg'] = '#319478;'
    themeObjects['--text-on-layout-two-bg'] = '#ffffff;'
  } else if (color === 'blackRed') {
    themeObjects['--background-color'] = 'linear-gradient(to right, #8e0e00, #4f1910);'
    themeObjects['--button-color'] = '#ffffff;'
    themeObjects['--toolbar-background'] = 'linear-gradient(to right, #8e0e00, #4f1910);'
    themeObjects['--background-linear'] = 'linear-gradient(to right, #8e0e00, #4f1910);'
    themeObjects['--color'] = '#ffffff;'
    themeObjects['--border-color'] = 'linear-gradient(to right, #8e0e00, #4f1910);'
    themeObjects['--active-color'] = '#ffffff;'
    themeObjects['--casino-bg'] = 'linear-gradient(to right, #8e0e00, #4f1910);'
    themeObjects['--text-on-bg'] = '#ffffff;'
    themeObjects['--main-color'] = '#8e0e00;'
    themeObjects['--secondary-bg'] = '#fffaf9;'
    themeObjects['--icon-bg'] = '#8e0e00;'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #8e0e00 400px, #000000ad 800px);'
  } else if (color === 'frost') {
    themeObjects['--background-color'] = 'linear-gradient(to right, #000428, #004e92);'
    themeObjects['--button-color'] = '#ffffff;'
    themeObjects['--toolbar-background'] = 'linear-gradient(to right, #000428, #004e92);'
    themeObjects['--background-linear'] = 'linear-gradient(to right, #000428, #004e92);'
    themeObjects['--color'] = '#ffffff;'
    themeObjects['--border-color'] = 'linear-gradient(to right, #000428, #004e92);'
    themeObjects['--active-color'] = '#ffffff;'
    themeObjects['--casino-bg'] = 'linear-gradient(to right, #000428, #004e92);'
    themeObjects['--text-on-bg'] = '#ffffff;'
    themeObjects['--main-color'] = '#4751ad;'
    themeObjects['--secondary-bg'] = '#eaf5ff;'
    themeObjects['--icon-bg'] = '#4751ad;'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #000428 400px, #000000ad 800px);'
  } else if (color === 'dark') {
    themeObjects['--background-color'] = '#333333;'
    themeObjects['--button-color'] = '#ffffff;'
    themeObjects['--toolbar-background'] = '#333333a1;'
    themeObjects['--background-linear'] = '#333333;'
    themeObjects['--color'] = '#ffffff;'
    themeObjects['--border-color'] = '#ffffff;'
    themeObjects['--active-color'] = '#ffffff;'
    themeObjects['--casino-bg'] = '#333333;'
    themeObjects['--text-on-bg'] = '#ffffff;'
    themeObjects['--main-color'] = '#6d6d6d;'
    themeObjects['--secondary-bg'] = '#ffffff;'
    themeObjects['--icon-bg'] = '#505050;'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, black, #333333 400px, black 800px);'
  } else if (color === 'LightBlue') {
    themeObjects['--background-color'] = '#2c6ec9;'
    themeObjects['--button-color'] = '#ffffff;'
    themeObjects['--toolbar-background'] = 'linear-gradient(315deg,#5e079a 10%,#4e3db1,#4550b4,#1c7bd3);'
    themeObjects['--background-linear'] = '#000000;'
    themeObjects['--color'] = '#ffffff;'
    themeObjects['--border-color'] = '#ffffff;'
    themeObjects['--active-color'] = '#ffffff;'
    themeObjects['--casino-bg'] = '#333333;'
    themeObjects['--text-on-bg'] = '#ffffff;'
    themeObjects['--main-color'] = '#2e6dc9;'
    themeObjects['--secondary-bg'] = 'linear-gradient(to left,#5e079a 10%,#4e3db1,#4550b4,#1c7bd3);'
    themeObjects['--landing-page-text-area'] = 'linear-gradient(to right, #000000ad, #2c6ec9 400px, #000000ad 800px);'
    themeObjects['--layout-two-main-bg'] = '#4848b2;'
    themeObjects['--text-on-layout-two-bg'] = '#ffffff;'
  }
  // Always
  themeObjects['--light-bg'] = '#e8e8e8;'
  globalCssVars = themeObjects
  const theme = document.querySelector('#gambling-checkout-vars')
  const lightTheme = theme && theme.innerHTML.includes('checkout-theme:light')
  if (lightTheme) {
    themeObjects['--nav-line'] = globalCssVars['--background-color']
  }
  const head: any = document.querySelector('head')
  const styleTag: any = document.querySelector('#gambling-theme-vars') || document.createElement('style')
  styleTag.id = 'gambling-theme-vars'
  let str: string = ''
  for (const i in themeObjects) {
    if (i) {
      str += `${i}:${themeObjects[i]}`
    }
  }
  styleTag.innerHTML = `
   :root {
     ${str}
   }
  `
  head.appendChild(styleTag)
  setUpCashierTheme(color)
}

const setUpCashierTheme = (color: string) => {
  switch (color) {
    case 'yellow':
      Store.dispatch('setConfigs', YellowTheme.config)
      Store.dispatch('setTheme', YellowTheme.theme)
      Store.commit('setCustomCss', YellowTheme.style)
      break;
    case 'PIQGreen':
      Store.dispatch('setConfigs', PIQGreenTheme.config)
      Store.dispatch('setTheme', PIQGreenTheme.theme)
      Store.commit('setCustomCss', PIQGreenTheme.style)
      break;
    default:
      Store.dispatch('setConfigs', YellowTheme.config)
      Store.dispatch('setTheme', YellowTheme.theme)
      Store.commit('setCustomCss', YellowTheme.style)
      break;
  }
}

export const lightOrDarkTheme = (theme: string = 'dark') => {
  const themeObjects: object | any = {}
  if (theme === 'light') {
    themeObjects['--checkout-theme'] = 'light;'
    themeObjects['--checkout-bg'] = '#f1f1f1;'
    themeObjects['--checkout-bg-text'] = '#333333;'
    themeObjects['--checkout-nav-bg'] = '#c7c7c7;'
    themeObjects['--checkout-nav-bg-active'] = '#f1f1f1;'
    themeObjects['--nav-active-color'] = '#555555;'
    themeObjects['--nav-line'] = globalCssVars['--background-color']
    themeObjects['--nav-line-filter'] = 'contrast(0.3);'
    themeObjects['--nav-account-color'] = '#555555;'
    themeObjects['--circle-line-color'] = '#777777;'
  } else if (theme === 'dark') {
    themeObjects['--checkout-theme'] = 'dark;'
    themeObjects['--checkout-bg'] = '#777777;'
    themeObjects['--checkout-bg-text'] = '#ffffff;'
    themeObjects['--checkout-nav-bg'] = '#505050;'
    themeObjects['--checkout-nav-bg-active'] = '#777777;'
    themeObjects['--nav-line'] = '#424242;'
    themeObjects['--nav-line-filter'] = 'contrast(1);'
    themeObjects['--nav-account-color'] = '#ffffff;'
    themeObjects['--circle-line-color'] = '#ffffff;'
  }
  return themeObjects
}

export const setCheckoutTheme = (theme: string = 'dark') => {
  const themeObjects: object | any = lightOrDarkTheme(theme)
  const head: any = document.querySelector('head')
  const styleTag: any = document.querySelector('#gambling-checkout-vars') || document.createElement('style')
  styleTag.id = 'gambling-checkout-vars'
  let str: string = ''
  for (const i in themeObjects) {
    if (i) {
      str += `${i}:${themeObjects[i]}`
    }
  }
  styleTag.innerHTML = `
   :root {
     ${str}
   }
  `
  head.appendChild(styleTag)
}

export const setCashierThemeLightOrDark = (setTheme: any, lightTheme: boolean, customBg: undefined | string) => {
  if (lightTheme) {
    setTheme({
      cashierbackground: {
        color: customBg || '#f1f1f1'
      },
      labels: {
        color: '#333333'
      },
      headings: {
        color: '#333333'
      }
    })
  } else {
    setTheme({
      cashierbackground: {
        color: '#777777'
      },
      labels: {
        color: '#ffffff'
      },
      headings: {
        color: '#ffffff'
      }
    })
  }
}

export const setThemeConfigs = (setTheme: void, checkoutThemeCallback: any): void => {
  const theme: any = document.querySelector('#gambling-checkout-vars')
  const lightTheme = theme && theme.innerHTML.includes('checkout-theme:light')
  if (lightTheme) {
    checkoutThemeCallback && checkoutThemeCallback('light')
  } else {
    checkoutThemeCallback && checkoutThemeCallback('dark')
  }
  setCashierThemeLightOrDark(setTheme, lightTheme, undefined)
}

export const checkForSavedConfigs = (): CheckForSavedConfigsCtx => {
  const __CASHIER_DEMO_CONFIGS__: string = localStorage.getItem(localStorageConfigsName) || '{}'
  return JSON.parse(__CASHIER_DEMO_CONFIGS__)
}

export const saveToLocalStorage = (customConfigs: Partial<CheckForSavedConfigsCtx> = {}): void => {
  const basicConfigs = {
    merchantId: Store.state.cashierContext.config.merchantId,
    userId: Store.state.cashierContext.config.userId,
    sessionId: Store.state.cashierContext.config.sessionId,
    environment: Store.state.cashierContext.config.environment
  }
  const __CASHIER_DEMO_CONFIGS__: CheckForSavedConfigsCtx = checkForSavedConfigs()
  const newConfigs = {
    ...basicConfigs,
    ...__CASHIER_DEMO_CONFIGS__ && __CASHIER_DEMO_CONFIGS__,
    ...customConfigs && customConfigs,
    demoThemesOptions: {
      checkoutBg: 'light', // default
      ...__CASHIER_DEMO_CONFIGS__ && __CASHIER_DEMO_CONFIGS__.demoThemesOptions,
      ...customConfigs.demoThemesOptions && customConfigs.demoThemesOptions
    }
  }
  localStorage.setItem(localStorageConfigsName, JSON.stringify(newConfigs))
}

export const setCountryUserId = (userId: string): void => {
  if (!window.createdFromGamblingHome) {
    Store && Store.dispatch('reloadCashier', { userId })
    Store && Store.dispatch('setCurrency')
    saveToLocalStorage({
      userId
    })
  }
}

export const openAccount = (type: string, ctx: any) => {
  const modalLayouts = [
    'layout2',
    'layout4'
  ]
  ctx.setAccountType(type)
  const pageLayoutCheck = modalLayouts.includes(ctx.pageLayout)
  if (!pageLayoutCheck) {
    ctx.$cashierConfigs('bankingPageFlow', { method: 'deposit', showHeader: !ctx.$smallScreen })
    ctx.$routeChange('/gambling/account')
  } else if (!pageLayoutCheck && type === 'banking') {
    ctx.$cashierConfigs('dynamicCashierType')
    ctx.setDrawerMiniVariant(false)
    ctx.$routeChange('/gambling')
  } else if (type === 'account' && pageLayoutCheck) {
    ctx.openAccountModal = true
  } else if (pageLayoutCheck) {
    ctx.$cashierConfigs('updateLatest')
  }
}

export const clearOldWebstorage = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.includes('__CASHIER_DEMO_CONFIGS') && key !== localStorageConfigsName) {
      localStorage.removeItem(key)
    }
  })
}
